module.exports = __webpack_public_path__ + "static/img/read.0a96d8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/read.png
// module id = vyVm
// module chunks = 0